import { useState } from "react";
import { useAppSelector } from "../../store/hooks";
import labels from "../../utils/labels";
import TabButton from "../UI/tab/TabButton";
import VisitHoursWrapper from "./VisitHoursWrapper";
import ColouredRoundWrapper from "../UI/wrappers/ColouredRoundWrapper";
import SubTasksList from "./SubTasksList";
import EmployeePreferences from "./EmployeePreferences";
import TaskDependenciesList from "./TaskDependenciesList";
import ViolationBox from "./ViolationBox";
import WarningBox from "./WarningBox";
import CitizenAppointmentModifiedBox from "./CitizenAppointmentModifiedBox";
import { SelectedTask } from "../../store/drawer";
import drawerStyles from "../../styles/drawer.module.css";
import GeneralTaskInfoBox from "./GeneralTaskInfoBox";

type TaskBarType = "VISIT" | "CITIZEN";
type TaskBarObject = { title: string; type: TaskBarType };

const TaskDrawerContent = () => {
  const selectedTask = useAppSelector(
    (state) => state.drawerSlice.selectedTask,
  );
  const [selected, setSelected] = useState<TaskBarType>("VISIT");

  const tabBarValues: TaskBarObject[] = [
    { title: labels.visit, type: "VISIT" },
    { title: labels.citizen, type: "CITIZEN" },
  ];

  const hasMissingLocationCoordinates = (task: SelectedTask["task"]) => {
    return (
      (!task.endLocation.latitude && !task.endLocation.longitude) ||
      (!task.startLocation.latitude && !task.startLocation.longitude)
    );
  };

  return (
    <>
      {selectedTask && (
        <div className={drawerStyles.drawerContent}>
          {/* tabs */}
          <div className={drawerStyles.drawerStickySubHeader}>
            <ColouredRoundWrapper
              bgColor="var(--col-surface-secondary)"
              width="100%"
              height=""
            >
              {tabBarValues.map((tab, index) => (
                <TabButton
                  key={index}
                  fullWidth
                  tabTitle={
                    tab.type === "VISIT"
                      ? labels.visitDetails
                      : labels.employees
                  }
                  onClick={() => setSelected(tab.type)}
                  selected={
                    selected === "VISIT"
                      ? labels.visitDetails
                      : labels.employees
                  }
                />
              ))}
            </ColouredRoundWrapper>
          </div>

          {/* violation and warning boxes */}
          {selectedTask.task.citizenAppointments &&
            selectedTask.task.citizenAppointments.length > 0 && (
              <CitizenAppointmentModifiedBox />
            )}

          {selectedTask.task.violations.length > 0 && (
            <ViolationBox
              violations={selectedTask.task.violations}
              violationOnUnplannedTask={
                selectedTask.task.taskStatusCode === "NOT_SCHEDULED"
              }
            />
          )}

          {/* Technically this is currently all or nothing. So if there is a startLocation, there is also an endLocation,
           and if they have latitude they also have longitude, but this is future proff. */}
          {hasMissingLocationCoordinates(selectedTask.task) && (
            <WarningBox violations={selectedTask.task.violations} />
          )}

          <GeneralTaskInfoBox />

          <div className="grey-line"></div>
          {/* tab specific info */}
          <div className={drawerStyles.drawerContent}>
            {selected === "VISIT" && (
              <>
                <VisitHoursWrapper task={selectedTask.task!} />
                <SubTasksList task={selectedTask.task!} />
                <TaskDependenciesList task={selectedTask.task} />
              </>
            )}
            {selected === "CITIZEN" && (
              <EmployeePreferences
                preferences={selectedTask.task.preferences}
                employeeName={selectedTask.employeeName}
                idServiceClient={selectedTask.task.client.idServiceClient}
                idTask={selectedTask.task.idTask}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default TaskDrawerContent;
